import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { SwitchNum } from '@umu/umu-types';

interface IIsTeacher {
	role_type: string;
	is_teacher: SwitchNum;
}
/**
 * @desc 判断当前用户是否是某个内容的讲师
 * @link https://yapi.umu.work/project/96/interface/api/3879
 * @params id 内容id sourceType int, 内容类型 1. 课程 3. 学习项目 4. 小节
*/
export const isCourseCooperator = (id: string | number, sourceType = 1): Promise<IResponse<IIsTeacher>> => {
	return fetchData(Api.IS_COOPERATOR, {
		id: id,
		type: sourceType,
	});
};
